import { TIconProps } from './utils';

export const RemoveCrossIcon = ({ className = '' }: TIconProps) => (
  <svg
    className={className}
    width='21'
    height='21'
    viewBox='0 0 21 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      id='Vector'
      d='M12.4029 10.7121L20.5757 18.885L18.885 20.5757L10.7121 12.4029L10.5 12.1907L10.2879 12.4029L2.115 20.5757L0.424264 18.885L8.59713 10.7121L8.80926 10.5L8.59713 10.2879L0.424264 2.115L2.115 0.424264L10.2879 8.59713L10.5 8.80926L10.7121 8.59713L18.885 0.424264L20.5757 2.115L12.4029 10.2879L12.1907 10.5L12.4029 10.7121Z'
      fill='#CDCDCD'
      stroke='white'
      strokeWidth='0.6'
    />
  </svg>
);
